export default "__VITE_ASSET__hjRPfhTm__"